import { isReactNativeApp, sendToNative } from '@mobi/web-native-comms/web'
import { trackLoginFailed } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import { refreshLogonState } from './refreshLogonState'
import { logon } from './api'
import { LogonRequestData, LogonResult } from '@mobi/api-types'

export const attemptLogin = async (data: LogonRequestData): Promise<AttemptLoginReturn> => {
  try {
    const result = await logon(data)

    switch (result.status) {
      case 'SUCCESSFUL': {
        refreshLogonState()
        return result
      }
      case 'MFA_REQUIRED': {
        return result
      }
      default: {
        if (result.status !== 'PASSWORD_CHANGE_REQUIRED') trackLoginFailed(data.accountIdentifier)
        // Only the React Native app needs to be notified. It hooks into this message and removes
        // credentials from the phone's KeyChain as they're no longer valid.
        if (isReactNativeApp && !!data.loginViaBioAuth) {
          sendToNative('INCORRECT_PASSWORD_OR_ACCOUNT', {
            // if loginViaBioAuth is set accountIdentifier will be an account #
            accountNumber: parseInt(data.accountIdentifier) || 0,
          })
        }

        return {
          ...result,
          errorMessage:
            result.error || 'The account or password details you entered are invalid. Please try again.',
        }
      }
    }
  } catch {
    return {
      status: 'FAILED',
      errorMessage: 'Sorry, something went wrong. Please try again.',
    }
  }
}

// =====
// Types
// =====

type AttemptLoginReturn = LogonResult & {
  errorMessage?: string
}
